export default class TabManager {
  /**
    * Constructor
    */
  constructor() {
    const self = this;
    document.querySelectorAll('.tabTrigger').forEach((element) => {
      element.addEventListener('click', self.changeTabContents);
    });

    this.init();
  }

  /**
     * タブの表示を初期状態に戻す
     */
  init=() => {
    (<HTMLElement>document.querySelector('.tabControllerGroup').querySelector('.tabTrigger')).click();
  }

    /**
     * タブの表示切替
     */
    changeTabContents = (e: Event) => {
      const target = (<HTMLElement>e.currentTarget).getAttribute('data-tabtrigger');
      const { children } = document.querySelector(target).closest('.tabContentsGroup');
      if ((e.currentTarget as HTMLElement).classList.contains('notAllowed')) return;
      for (let i:number = 0; i < children.length; i += 1) {
        const child: HTMLElement = children[i] as HTMLElement;
        if (child.classList.contains('tabContent')) {
          child.style.display = 'none';
        }
        (<HTMLElement>document.querySelector(target)).style.display = 'block';
      }
    }
}
